import {
  SET_CONSOLIDATED_EW_LOADING,
  SET_CONSOLIDATED_EW_TABLE_DATA,
  CLEAR_CONSOLIDATED_EW_STATE
} from './consolidatedEwCreatorActionType';

const initialState = {
  isLoading: false,
  tableData: [],
  error: null
};

const consolidatedEwCreatorReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CONSOLIDATED_EW_LOADING:
      return {
        ...state,
        isLoading: action.payload
      };

    case SET_CONSOLIDATED_EW_TABLE_DATA:
      return {
        ...state,
        tableData: action.payload
      };

    case CLEAR_CONSOLIDATED_EW_STATE:
      return {
        ...initialState
      };

    default:
      return state;
  }
};

export default consolidatedEwCreatorReducer;
